import React from 'react';

import handL from "assets/img/newversion/whoweare-hand-rigth.png";
import handR from "assets/img/newversion/whoweare-hand-left.png";


export const HeroBackground = () => {
  return (
    <>
      {/* Desktop layout - both images positioned absolutely with proper visibility */}
      <img
        // src="https://api.builder.io/api/v1/image/assets/TEMP/f0948ae72ed7834342e5bec2bb3a5b7b451dcafb?width=782"
        src={handR}        
        alt=""
        className="position-absolute d-none d-md-block"
        style={{
          top: '70px',
          right: '-1px',
          opacity: '0.6',
          maxWidth: '350px',
          width: 'auto',
          height: 'auto',
          // transform: 'rotate(-63.989deg)',
          zIndex: '1',
          pointerEvents: 'none'
        }}
      />
      <img
        // src="https://api.builder.io/api/v1/image/assets/TEMP/a26fbef8dea549994976a5c5f23a8cc6da7036ae?width=554"
        src={handL}        
        alt=""
        className="position-absolute d-none d-md-block"
        style={{
          left: '-1px',
          top: '100px',
          opacity: '0.6',
          maxWidth: '350px',
          width: 'auto',
          height: 'auto',
          zIndex: '1',
          pointerEvents: 'none'
        }}
      />
    </>
  );
};
